// This can be our future entry point
import './babel/modules';
import './fonts/upicons.scss';
import 'App/pages/FullScreenPage/FullScreenPage.scss';
import './styles/legacy-dynamic-styles';
import './babel/angularConfig';
import './babel/angular/general';
import './babel/angular/resources';
import './babel/angular/filters';
import './babel/angular/security';
import './babel/angular/components';
import App from './App';
import { createRoot } from 'react-dom/client';
import './index.scss';
import { mapDate, mapDates } from './resources/genericMapper';
import { parseDate, parseDates } from './resources/genericParser';
import LZString from 'lz-string';
import history from 'App/pages/routes/history';
import findAll from './babel/helpers/findAll';
import DataCache from 'App/babel/services/DataCache';
import { WithSplitProvider } from 'App/services/feature';

// Capture the Chrome side-panel marker (?upsalesExtension=1) at the earliest point —
// before any router runs — and persist it for the session so it survives the post-login
// navigation. Read by App/pages/EmbedAIChat/panelContext. WEB-7101.
try {
	if (new URLSearchParams(window.location.search).get('upsalesExtension') === '1') {
		window.sessionStorage.setItem('upsalesExtension', '1');
	}
} catch {
	// sessionStorage unavailable (privacy mode) — panel detection falls back to the query param.
}

const root = createRoot(document.getElementById('react-root'));
root.render(
	<WithSplitProvider>
		<App />
	</WithSplitProvider>
);

// TODO: Remove when getting rid of Tools
window.Tools.mapDate = mapDate;
window.Tools.mapDates = mapDates;
window.Tools.parseDate = parseDate;
window.Tools.parseDates = parseDates;
window.Tools.LZString = LZString;
window.Tools.routerHistory = history;
window.Tools.DataCache = DataCache;
window.Tools.findAll = findAll;

require('./babel/legacy-dynamic-load');
require('./babel/legacy-react');
require('./babel/angular/directives');
require('./babel/angular/common');
require('./babel/angular/domain');
